<section class="perm-summary" aria-label="Resumo do grupo">
  <div class="perm-summary__bar">
    <i class="pi pi-shield perm-summary__icon"></i>
    <p class="perm-summary__text">
      @if (summary().permissions) {
        Este grupo dá
        <b
          >{{ summary().permissions }}
          {{ summary().permissions === 1 ? 'permissão' : 'permissões' }}</b
        >
        em <b>{{ modulesText() }}</b> ·
        <b>{{ summary().menuScreens }} {{ summary().menuScreens === 1 ? 'tela' : 'telas' }}</b>
        {{ summary().menuScreens === 1 ? 'aparece' : 'aparecem' }} no menu
      } @else {
        Nenhuma permissão marcada ainda. Escolha uma tela à esquerda ou use <b>Só leitura</b> num
        módulo.
      }
    </p>
    @if (changes().length) {
      <button
        type="button"
        class="perm-summary__toggle"
        [attr.aria-expanded]="open()"
        aria-controls="perm-summary-changes"
        (click)="toggle()">
        <span class="perm-summary__dot"></span>
        {{ changesLabel() }}
        <i class="pi" [class.pi-chevron-up]="open()" [class.pi-chevron-down]="!open()"></i>
      </button>
    }
  </div>

  @if (open() && changes().length) {
    <div class="perm-summary__changes" id="perm-summary-changes">
      <div class="perm-summary__changes-head">
        <p class="perm-summary__changes-title">O que muda ao salvar</p>
        @if (isEditing()) {
          <span class="perm-summary__changes-note"
            >Vale para todos os usuários do grupo no próximo acesso.</span
          >
        }
        <app-button
          class="perm-summary__undo-all"
          [id]="'undo-all-changes'"
          label="Desfazer tudo"
          size="small"
          theme="white"
          [noMargin]="true"
          (sendButtonClick)="undo()"></app-button>
      </div>
      <div class="perm-summary__columns">
        @if (added().length) {
          <div class="perm-summary__column">
            <p class="perm-summary__column-title perm-summary__column-title--added">
              Ganha {{ added().length }}
            </p>
            <ul>
              @for (change of added().slice(0, maxListed); track change.value) {
                <li>
                  <span class="perm-summary__change-text">
                    <span class="perm-summary__change-label">{{ change.label }}</span>
                    <span class="perm-summary__change-where">{{ change.where }}</span>
                  </span>
                  <button
                    type="button"
                    class="perm-summary__undo-one"
                    [attr.aria-label]="'Desfazer: ' + change.label"
                    (click)="undoOne.emit(change.value)">
                    desfazer
                  </button>
                </li>
              }
              @if (added().length > maxListed) {
                <li class="perm-summary__more">e mais {{ added().length - maxListed }}</li>
              }
            </ul>
          </div>
        }
        @if (removed().length) {
          <div class="perm-summary__column">
            <p class="perm-summary__column-title perm-summary__column-title--removed">
              Perde {{ removed().length }}
            </p>
            <ul>
              @for (change of removed().slice(0, maxListed); track change.value) {
                <li>
                  <span class="perm-summary__change-text">
                    <span class="perm-summary__change-label">{{ change.label }}</span>
                    <span class="perm-summary__change-where">{{ change.where }}</span>
                  </span>
                  <button
                    type="button"
                    class="perm-summary__undo-one"
                    [attr.aria-label]="'Desfazer: ' + change.label"
                    (click)="undoOne.emit(change.value)">
                    desfazer
                  </button>
                </li>
              }
              @if (removed().length > maxListed) {
                <li class="perm-summary__more">e mais {{ removed().length - maxListed }}</li>
              }
            </ul>
          </div>
        }
      </div>
      @if (keptUnknown()) {
        <p class="perm-summary__changes-foot perm-summary__changes-note">
          {{ keptUnknown() }}
          {{
            keptUnknown() === 1
              ? 'permissão antiga que não existe mais para este tipo continua'
              : 'permissões antigas que não existem mais para este tipo continuam'
          }}
          no grupo.
        </p>
      }
    </div>
  }
</section>
